import React, { useState, useEffect } from "react";
import img1 from "../assest/sidelogo.png";
import img2 from "../assest/qrcode-icon.png";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import "./OfficeReview.css";
import { getFeedbackSummary } from "../Api/apiendpoints";

const OfficeReview = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [officeData, setOfficeData] = useState([]);
  const [loading, setLoading] = useState(true);

  const tabs = ["All", "Block", "Tahasil", "GPs", "Others"];

  const getOfficeType = (name) => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes("block")) return "Block";
    if (lowerName.includes("tahasil")) return "Tahasil";
    if (lowerName.includes("panchayat")) return "GPs";
    return "Others";
  };

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        setLoading(true);
        const res = await getFeedbackSummary();
        const apiData = res?.data || [];

        // const formattedData = apiData.map((item) => ({
        //   name: item.officeName,
        //   type: getOfficeType(item.officeName),
        //   rating: Math.round(item.averageRating || 0),
        //   reviews: item.totalReviews || 0,
        // }));

        // const formattedData = apiData.map((item) => {
        //   const feedbacks = item.feedbacks || [];
        //   const total = feedbacks.length;
        //   let rating = "0.0";
        //   if (total > 0) {
        //     const sum = feedbacks.reduce((acc, curr) => acc + (Number(curr.overallSatisfaction) || 0), 0);
        //     rating = Math.max(0, sum / total - 0.5).toFixed(1);
        //   }
        //   return {
        //     name: item.officeName,
        //     type: getOfficeType(item.officeName),
        //     rating,
        //     reviews: item.totalReviews || total,
        //   };
        // });

        const formattedData = apiData.map((item) => {
  const avg = item.averageRating || 0;
  const rating = Math.max(0, avg - 0.5).toFixed(1);
  
  return {
    name: item.officeName,
    type: getOfficeType(item.officeName),
    rating,
    reviews: item.totalReviews || 0,
  };
});

        setOfficeData(formattedData);
      } catch (error) {
        console.error("Feedback API failed", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFeedback();
  }, []);

  const filteredData = officeData.filter((item) => {
    const tabMatch = activeTab === "All" ? true : item.type === activeTab;
    const searchMatch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
    return tabMatch && searchMatch;
  });

  const sortedData = [...filteredData].sort((a, b) => (b.reviews || 0) - (a.reviews || 0));

  // const renderStars = (rating) =>
  //   [...Array(5)].map((_, i) => (
  //     <span key={i} className={`officereview-star ${i < rating ? "filled" : ""}`}>
  //       ★
  //     </span>
  //   ));

  const renderStars = (rating) => {
    const num = parseFloat(rating) || 0;
    const fullStars = Math.floor(num);
    const emptyStars = 5 - fullStars;
    return (
      <>
        {Array(fullStars).fill(null).map((_, i) => (
          <span key={`full-${i}`} className="officereview-star filled">★</span>
        ))}
        {Array(emptyStars).fill(null).map((_, i) => (
          <span key={`empty-${i}`} className="officereview-star">★</span>
        ))}
      </>
    );
  };
  return (
    <div className="officereview-container">
      {/* TOP BAR */}
      <div className="blockfeedbackpage-header">
        <div className="header-left">
          <img src={img1} className="header-logo" alt="Gov Logo" />
          <span>Government Of Odisha</span>
        </div>
        <span className="feedbacklistpage-back-btn">
          <img src={img2} className="dhenkanal-logo" alt="QR Logo" />
          DHENKANAL 360
        </span>
      </div>

      {/* HEADER */}
      <div className="officereview-header">
        <div className="officereview-header-left">
          <IoIosArrowBack className="officereview-back-icon" onClick={() => navigate(-1)} />
          <h2>Feedback</h2>
        </div>
        <input
          className="officereview-search"
          type="text"
          placeholder="By Office..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* TABS WITH OTHERS DISABLED */}
      <div className="officereview-tabs">
        {tabs.map((tab) => {
          // Check if data exists OR if it's the "Others" tab (Force Disable)
          const hasData = tab === "All" || officeData.some((item) => item.type === tab);
          const isOthers = tab === "Others";
          const isDisabled = !hasData || isOthers;

          return (
            <button
              key={tab}
              disabled={isDisabled}
              className={`officereview-tab ${activeTab === tab ? "active" : ""} ${isDisabled ? "tab-locked" : ""
                }`}
              onClick={() => !isDisabled && setActiveTab(tab)}
            >
              {tab}
            </button>
          );
        })}
      </div>

      {/* CARDS GRID */}
      <div className="officereview-grid">
        {loading ? (
          <p className="loading-text">Loading reviews...</p>
        ) : sortedData.length > 0 ? (
          sortedData.map((item, index) => (
            <div key={index} className="officereview-card">
              <div className={`officereview-ribbon ${item.type.replace(/\./g, "")}`}>
                {item.type}
              </div>
              <h3>{item.name}</h3>
              {/* <div className="officereview-rating">
                {renderStars(item.rating)}
                <span className="officereview-reviewtext">
                  {item.reviews} {item.reviews <= 1 ? "Review" : "Reviews"}
                </span>
              </div> */}
              <div className="officereview-rating">
                {renderStars(item.rating)}
                {/* <span className="officereview-rating-value">{item.rating}</span> */}
                <span className="officereview-reviewtext">
                  {item.reviews} {item.reviews <= 1 ? "Review" : "Reviews"}
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="no-data">No data found for "{activeTab}"</p>
        )}
      </div>
    </div>
  );
};

export default OfficeReview;